import { SegmentedControl } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("segmentedControl", react2angular(SegmentedControl, ["buttons", "className", "label", "disabled"]));
